import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationPageValuePayloadModel } from '../../../core/helpers';

import { ApiService } from '../../../core/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService {
    constructor(private apiService: ApiService) {}

    getCurrentApplication(userId: number): Observable<any> {
        let httpParams = new HttpParams().set('userId', userId.toString());
        return this.apiService.get('/applications/current', httpParams);
    }

    patchCurrentApplication(application: any): Observable<any> {
        return this.apiService.patch(
            `/applications/${application.applicationId}`,
            application
        );
    }

    getSelectedProviderContacts(applicationId: number): Observable<any> {
        return this.apiService.get(
            `/applications/${applicationId}/selectedprovidercontacts`
        );
    }

    getSelectedProviderPrograms(applicationId: number): Observable<any> {
        return this.apiService.get(
            `/applications/${applicationId}/selectedproviderprograms`
        );
    }

    getPersonalInfo(applicationId: number): Observable<any> {
        return this.apiService.get(
            `/applications/${applicationId}/personalinfo`
        );
    }

    savePersonalInfo(personalInfo: any): Observable<any> {
        return this.apiService.put(
            `/applications/${personalInfo.applicationId}/personalinfo`,
            personalInfo
        );
    }

    getBackground(applicationId: number): Observable<any> {
        return this.apiService.get(`/applications/${applicationId}/background`);
    }

    saveBackground(personalInfo: any): Observable<any> {
        return this.apiService.put(
            `/applications/${personalInfo.applicationId}/background`,
            personalInfo
        );
    }

    getEducation(applicationId: number): Observable<any> {
        return this.apiService.get(`/applications/${applicationId}/education`);
    }

    saveEducation(education: any): Observable<any> {
        return this.apiService.put(
            `/applications/${education.applicationId}/education`,
            education
        );
    }

    getDisclosure(applicationId: number): Observable<any> {
        return this.apiService.get(`/applications/${applicationId}/disclosure`);
    }

    saveDisclosure(disclosure: any): Observable<any> {
        return this.apiService.put(
            `/applications/${disclosure.applicationId}/disclosure`,
            disclosure
        );
    }

    getDynamicFormValues(
        applicationId: number,
        applicationPage: number
    ): Observable<any> {
        return this.apiService.get(
            `/applications/${applicationId}/pages/${applicationPage}`
        );
    }

    saveDynamicFormValues(
        applicationId: number,
        applicationPage: number,
        payload: ApplicationPageValuePayloadModel
    ): Observable<any> {
        return this.apiService.put(
            `/applications/${applicationId}/pages/${applicationPage}`,
            payload
        );
    }
}
